import React, {useContext, useEffect, useMemo, useState} from "react";
import AuthContext from "../Services/AuthContext";
import {Link, useLocation, useNavigate} from "react-router-dom";
// @mui material components
// Material Dashboard 2 PRO React components
// Images
import bgImage from "../splash.jpg";
import bgImage2 from "../splash2.jpg";
import bgImage3 from "../splash3.jpg";
import bgImage4 from "../splash4.jpg";
import SplashScreen from "../Layout/SplashScreen";
import {Alert, Box, Button, Paper, TextField, Typography} from "@mui/material";
import {Switch} from "@fluentui/react-components";

export default function LoginPage() {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [flash, setFlash] = useState('');
    const [user, setUser] = useContext(AuthContext);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    useEffect(() => {
        if (user.token !== "" && !location.pathname.endsWith('logout')) {
            navigate("/");
        }
    }, [user.token, navigate, location])

    useEffect(() => {
        if (location.pathname.endsWith('confirmed')) {
            setFlash(<Alert severity="success">Potwierdzono rejestrację konta w systemie.</Alert>);
        } else if (location.pathname.endsWith('expired')) {
            setFlash(<Alert severity="error">Link potwierdzający wygasł. Prosimy o ponowną rejestrację konta.</Alert>);
        } else if (location.pathname.endsWith('reseted')) {
            setFlash(<Alert severity="error">Zresetowano hasło. Zaloguj się na nowe dane.</Alert>);
        } else if (location.pathname.endsWith('logout')) {
            setFlash(<Alert severity="info">Wylogowano z systemu</Alert>);
            setUser({ username: "", facilities: [], members: [], token: "", isAnyAdmin: false});
        }
    }, [location])

    const authenticate = (e) => {
        if (!loading) {
            setLoading(true);
            e.preventDefault();
            const sentData = {username: username, password: password};

            fetch("/api/login_check", {
                cache: "no-cache",
                method: "post",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(sentData),
            })
                .then((response) => {
                    if (!response.ok) {
                        throw Error(response.statusText);
                    }
                    response.json().then(function (data) {
                        fetch("/api/actions", {
                            cache: "no-cache",
                            method: "get",
                            headers: {
                                'Authorization': 'Bearer ' + data.token
                            },
                        }).then((response) => {
                            if (!response.ok) {
                                throw Error(response.statusText);
                            }
                            response.json().then(function (actions) {
                                const user = {username: sentData.username, token: data.token, facilities: actions.facilities, members: actions.members};
                                setUser(user);
                                setLoading(false);
                                navigate('/');
                            }).catch((error) => {
                                setFlash(<Alert severity="error">Aplikacja niedostępna, proszę spróbować później.</Alert>);
                                console.log(error.message);
                                setLoading(false);
                            });
                    });
                })})
                .catch((error) => {
                    setFlash(<Alert severity="error">Niepoprawny login lub hasło.</Alert>);
                    console.log(error.message);
                    setLoading(false);
                });
        }

    };

    function getRandomIntInclusive(min, max) {
        min = Math.ceil(min);
        max = Math.floor(max);
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    const images = [bgImage, bgImage2, bgImage3, bgImage4];

    const bg = useMemo(
        () => {
            const today = new Date();
            if (today.getMonth() > 2 && today.getMonth() < 9) {
                return images[2];
            }
            return images[3];
        },[images],
    );

    return (
        <SplashScreen background={bg} title={'Wakacyjne Zajęcia'}>
            <Paper elevation={24} sx={{width: '500px', maxWidth: '80vw', overflow: 'visible', overflowWrap: 'break-word', backgroundClip: 'border-box', paddingTop: '1px'}}>
                <Box
                    mx={2}
                    mt={-3}
                    p={2}
                    mb={1}
                    textAlign="center"
                    sx={{background: 'linear-gradient(195deg, rgb(66, 66, 74), rgb(25, 25, 25))',
                        boxShadow: 'rgba(0, 0, 0, 0.14) 0rem 0.25rem 1.25rem 0rem, rgba(64, 64, 64, 0.4) 0rem 0.4375rem 0.625rem -0.3125rem',
                        margin: '-24px 16px 8px',
                        padding: '16px',
                        borderRadius: '0.375rem',
                        opacity: 1}}
                >
                    <Typography variant="h5" fontWeight="light" color="white">
                        Cześć!
                    </Typography>
                </Box>
                {flash}
                <Box pt={4} pb={2} px={3}>
                    <Box component="form" role="form" onSubmit={authenticate}>
                        <Box mb={2}>
                            <TextField autoFocus type="email" autoComplete="username" label="Email" value={username}
                                     onChange={(e) => setUsername(e.target.value)} fullWidth/>
                        </Box>
                        <Box mb={2}>
                            <TextField type="password" autoComplete="current-password" label="Hasło" value={password}
                                     onChange={(e) => setPassword(e.target.value)} fullWidth/>
                        </Box>
                        <Box sx={{justifyContent: 'space-around', display: 'flex'}}>
                            <Switch inlineLabel={true} label={'Zapamiętaj Mnie'} disabled/>
                            <Link to={`/reset`}><Button variant={'text'} color="anthracite" sx={{textAlign: 'right', marginTop: '4px'}} size={'small'}>Nie pamiętasz hasła?</Button></Link>
                        </Box>
                        <Box mt={2} mb={1}>
                            <Button disabled={loading} size={'large'} color="primary" variant={'contained'} fullWidth type={'submit'}>
                                Zaloguj
                            </Button>
                        </Box>
                        <Box sx={{textAlign: 'center'}}>
                            <Typography variant={'p'} fontSize={'large'} fontWeight="light">Nie masz konta? <Link to={`/register`}><Button variant={'text'} color="anthracite" size={'small'}>Zarejestruj się!</Button></Link></Typography>
                        </Box>
                    </Box>
                </Box>
            </Paper>


        </SplashScreen>
    );
}
